import { Typography } from '@mui/material'
import React from 'react'

function Loading() {
    return (
        <Typography variant='body1' color={'primary.main'} textAlign={'center'}>Data Is Loading.......</Typography>
    )
}

export default Loading
